import React from 'react';

export const CheckmarkSuccessSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
    >
      <path
        d="M47.63 104.1L55.83 112.3L53 115.13L44.8 106.93L47.63 104.1ZM60 23.26C80.2909 23.26 96.74 39.7091 96.74 60C96.74 80.291 80.2909 96.74 60 96.74C39.7091 96.74 23.26 80.291 23.26 60C23.26 39.7091 39.7091 23.26 60 23.26ZM10.85 66.63L13.68 69.45L5.47 77.66L2.65 74.83L10.85 66.63ZM111 58.18C112.867 58.18 114.38 59.6933 114.38 61.56C114.38 63.4267 112.867 64.94 111 64.94C109.133 64.94 107.62 63.4267 107.62 61.56C107.62 59.6933 109.133 58.18 111 58.18ZM56.7 3.76001L64.9 12L62.07 14.8L53.87 6.59001L56.7 3.76001Z"
        fill="#116DFF"
      />
      <path
        d="M55.58 74.92L42.74 62.08L46.98 57.82L55.58 66.44L75.54 46.46L79.78 50.72L55.58 74.92Z"
        fill="white"
      />
      <path
        d="M109.15 78.37L117.35 86.58L114.52 89.4L106.32 81.2L109.15 78.37ZM112.54 21.42L109.88 31.34L102.62 24.08L112.54 21.42ZM20.6 13.76L30.52 16.42L23.26 23.68L20.6 13.76Z"
        fill="#28BF9A"
      />
      <path
        d="M86.2 102.38C88.0667 102.38 89.58 103.893 89.58 105.76C89.58 107.627 88.0667 109.14 86.2 109.14C84.3333 109.14 82.82 107.627 82.82 105.76C82.82 103.893 84.3333 102.38 86.2 102.38ZM13.6 91.26L23.52 93.9L16.26 101.18L13.6 91.26ZM14 32.62C15.8667 32.62 17.38 34.1333 17.38 36C17.38 37.8667 15.8667 39.38 14 39.38C12.1333 39.38 10.62 37.8667 10.62 36C10.62 35.1036 10.9761 34.2439 11.61 33.61C12.2439 32.9761 13.1036 32.62 14 32.62ZM82.5 4C83.8671 4 85.0995 4.82351 85.6227 6.08653C86.1459 7.34955 85.8567 8.80335 84.89 9.77002C83.9233 10.7367 82.4695 11.0259 81.2065 10.5027C79.9435 9.97955 79.12 8.74708 79.12 7.38C79.12 5.51328 80.6333 4 82.5 4Z"
        fill="#FFD527"
      />
    </svg>
  );
};
